import React, { useState } from 'react';
import { Typography, Card, CardActions, CardContent, CardMedia, IconButton, Container } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
// import CircularProgress from '@material-ui/core/CircularProgress';
import Progress from '../../MySpinner/MySpinner'
import { FiChevronsUp, FiChevronsDown } from 'react-icons/fi';
import useStyles from './styles';

const CartItem = ({ item, incDecRemove }) => {
    const classes = useStyles();
    const [up, setUp] = useState(false);
    const [down, setDown] = useState(false);
    const [stateRemove, setRemove] = useState(false);

    const increment = async (id, quantity) => {
        setUp(true);
        await incDecRemove("inc", id, quantity);
    };

    const decrement = async (id, quantity) => {
        setDown(true);
        await incDecRemove("dec", id, quantity);
    };

    const remove = async (id) => {
        setRemove(true);
        await incDecRemove("remove", id);
    };

    return (
        <Card className={classes.root}>
            <CardMedia image={item.media.source} alt={item.name} className={classes.media} />
            <CardContent className={classes.cardContent}>
                <Typography variant="h4">{item.name}</Typography>
                <Typography variant="subtitle1">
                    Unite Price: <span className={classes.span}>&nbsp; {item.price.formatted_with_symbol}</span>
                </Typography>
                <Typography variant="subtitle1">
                    Quantity: <span className={classes.span}>&nbsp; {item.quantity}</span>
                </Typography>
                <Typography variant="subtitle1">
                    Total Units Price: <span className={classes.span}>&nbsp; {item.line_total.formatted_with_symbol}</span>
                </Typography>
            </CardContent>

            <CardActions className={classes.cartActions}>
                {/* <Button variant = "contained" type = "button" color = "secondary" onClick = {async () => await incDecRemove("remove", item.id)}>Remove</Button> */}
                <IconButton className={classes.IconButton} aria-label="Remove" onClick={async () => await remove(item.id)}>
                    {
                        stateRemove ? (
                            <>
                                <Progress />
                            </>
                        ) : (
                            <DeleteIcon />
                        )
                    }
                </IconButton>

                <div className={classes.buttons}>
                    <IconButton className={classes.IconButton} aria-label="Decrement" onClick={async () => await decrement(item.id, item.quantity)}>
                        {
                            down ? (
                                <Progress />
                            ) : (
                                <FiChevronsDown />
                            )
                        }
                    </IconButton>

                    <Container className={classes.container}>
                        {item.quantity}
                    </Container>

                    <IconButton className={classes.IconButton} aria-label="Increment" onClick={async () => await increment(item.id, item.quantity)}>
                        {
                            up ? (
                                <Progress />
                            ) : (
                                <FiChevronsUp />
                            )
                        }
                    </IconButton>
                </div>
            </CardActions>

        </Card>
    )
}

export default CartItem
